<script>
import api from './api'
export default {
  load (id) {
    return api.get('partners/' + id)
  },
  save (id, formData) {
    if (!id) {
      return api.post('partners', formData)
    }
    return api.put('partners/' + id, formData)
  },
  activate (id) {
    return api.put(`partners/${id}/activate`)
  },
  inactivate (id) {
    return api.put(`partners/${id}/inactivate`)
  },
  list (params) {
    const preparedParams = params ? params.filter : {}
    return api.get('partners', preparedParams)
  },
  listAgents (partnerId, params) {
    return api.get(`partners/${partnerId}/agents`, params)
  },
  loadAgent (partnerId, id) {
    return api.get(`partners/${partnerId}/agents/${id}`)
  },
  saveAgent (partnerId, id, formData) {
    if (!id) {
      return api.post(`partners/${partnerId}/agents`, formData)
    }
    return api.put(`partners/${partnerId}/agents/${id}`, formData)
  },
  listAgents (partnerId, params) {
    return api.get(`partners/${partnerId}/agents`, params)
  }
}
</script>
